import { render } from "./UserUpload.vue?vue&type=template&id=56b95dbc&scoped=true&ts=true"
import script from "./UserUpload.vue?vue&type=script&lang=ts&scoped=true"
export * from "./UserUpload.vue?vue&type=script&lang=ts&scoped=true"

import "./UserUpload.vue?vue&type=style&index=0&id=56b95dbc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod_electronic-delivery-responsive_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b95dbc"]])

export default __exports__